module.exports = __webpack_public_path__ + "img/roll-1599.55302fda.png";